export const HOME = { emergentLink: "emergent-link" };

export const TID = {
  // Landing
  landingHero: "landing-hero",
  ctaGetStarted: "cta-get-started",
  ctaExploreMap: "cta-explore-map",
  navLogin: "nav-login",
  navSignup: "nav-signup",
  navLogout: "nav-logout",
  navMap: "nav-map",
  navProjects: "nav-projects",
  navAdmin: "nav-admin",
  navBookings: "nav-bookings",
  navCalc: "nav-calc",
  navCompare: "nav-compare",
  // Auth
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  signupName: "signup-name",
  signupEmail: "signup-email",
  signupPassword: "signup-password",
  signupPhone: "signup-phone",
  signupSubmit: "signup-submit",
  googleLogin: "google-login-btn",
  // Map
  mapContainer: "map-container",
  filterCorridor: "filter-corridor",
  filterConversion: "filter-conversion",
  filterOwner: "filter-owner",
  filterMinScore: "filter-min-score",
  filterMaxPrice: "filter-max-price",
  parcelCard: "parcel-card",
  parcelDetailOpen: "parcel-detail-open",
  parcelDetailClose: "parcel-detail-close",
  // Calc
  calcSize: "calc-size",
  calcRoad: "calc-road",
  calcZone: "calc-zone",
  calcProjectType: "calc-project-type",
  calcSubmit: "calc-submit",
  calcResult: "calc-result",
  // Advisory
  bookingConsultant: "booking-consultant",
  bookingDate: "booking-date",
  bookingSlot: "booking-slot",
  bookingNotes: "booking-notes",
  bookingSubmit: "booking-submit",
  // Admin
  adminAddParcel: "admin-add-parcel",
  adminAddInfra: "admin-add-infra",
  adminAddProject: "admin-add-project",
  adminLeadsTable: "admin-leads-table",
  adminEnquiriesTable: "admin-enquiries-table",
  compareToggle: "compare-toggle",
  compareBarOpen: "compare-bar-open",
};
